export default __webpack_public_path__ + "static/media/verify_confirm_icon.3f36ba58.svg";